import React from "react";

function ConfirmationModal({ isOpen, onClose, onConfirm, message }) {
    if (!isOpen) {
        return null;
    }
    return (
        <div className="confirmation-modal">
            <div className="confirmation-modal-content">
                <p>{message}</p>
                <button onClick={onConfirm}>Confirm</button>
                <button onClick={onClose}>Cancel</button>
            </div>
        </div>
    );
}

export default ConfirmationModal;